import request from 'utils/request'
// 添加或者编辑
export const add = data => request().post('riskLabel/addOrUpdate', data)

// 删除
export const remove = id => request().get(`riskLabel/delete/${id}`)
// 获取表格数据
export const getTableData = data => request().post('riskLabel/page', data)
